// 命令列表
export const commendList = [
    {name: '控制台命令', value: '0'},
    {name: '上传命令', value: '1'},
    {name: '下载命令', value: '2'},
    {name: '安装命令', value: '3'},
    {name: '执行脚本', value: '4'},
    {name: '更新程序', value: '5'},
    {name: '显示手机摘要信息', value: '6'},
    {name: '重启', value: '7'},
    {name: '截图', value: '8'},
    {name: '卸载', value: '9'},
    {name: '启动App', value: '10'},
    {name: '下载脚本', value: '11'},
    {name: '启动任务', value: '12'},
    {name: '停止任务', value: '13'},
    {name: '动态加载', value: '14'},
    {name: '开启录屏', value: '15'},
    {name: '关闭录屏', value: '16'},
    {name: '升级rom', value: '17'},
    {name: '升级xposed', value: '18'},
    {name: '更改xposed模块列表', value: '19'},
];



// WEBPACK FOOTER //
// ./utils/enums.js